/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringCriteriaRangeResponse
 */
export interface StringCriteriaRangeResponse {
    /**
     * 
     * @type {string}
     * @memberof StringCriteriaRangeResponse
     */
    from?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StringCriteriaRangeResponse
     */
    to?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StringCriteriaRangeResponse
     */
    exclude?: boolean;
}

export function StringCriteriaRangeResponseFromJSON(json: any): StringCriteriaRangeResponse {
    return StringCriteriaRangeResponseFromJSONTyped(json, false);
}

export function StringCriteriaRangeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringCriteriaRangeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function StringCriteriaRangeResponseToJSON(value?: StringCriteriaRangeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from,
        'to': value.to,
        'exclude': value.exclude,
    };
}


